import React from 'react';

export const MainContext = React.createContext();

export default function withContext(Component) {
  return function contextComponent(props) {
    return (
      <MainContext.Consumer>
        {(context) => <Component {...props} context={context} /> /* eslint-disable-line react/jsx-props-no-spreading */}
      </MainContext.Consumer>
    );
  };
}
